import React, { useEffect, useRef, useState } from "react";

import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import { Ask_Question, Show_Message } from "../General/Messagedialogbox";
import { API_FETCH, API_POST } from "../General/Utility";
import ReactTable from "../General/ReactTable";
import CustomeIndexSelectOption from "../General/CustomeIndexSelectOption";
import { Is_ValidResponse } from "./ReportTable";

// Keep the value's original type (number stays number) so the API model binds the same way as before
// (a non-numeric entry stays text so the Update check below can reject it)
const OrigTypes = new WeakMap();
const Remember_Types = (arrRows) => {
  arrRows.forEach((row) => {
    if (row && typeof row === "object")
      OrigTypes.set(row, { inOrderTo: typeof row.inOrderTo, reportWidth: typeof row.reportWidth, fontAlign: typeof row.fontAlign });
  });
  return arrRows;
};
const Set_Field = (row, strField, NewValue) => {
  const objTypes = OrigTypes.get(row) || {};
  row[strField] =
    objTypes[strField] === "number" && String(NewValue).trim() !== "" && !isNaN(Number(NewValue))
      ? Number(NewValue)
      : NewValue;
};
const Is_Number = (Value) => String(Value === null || Value === undefined ? "" : Value).trim() !== "" && !isNaN(Number(Value));

function ReportSetting(props) {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  const _parem = useSelector((state) => state.SelectOption.parems);
  const [arrEntDT, setarrEntDT] = useState([]);
  const [arrColSetting, setarrColSetting] = useState([]);
  const [arrEntReptCol, setarrEntReptCol] = useState([]);
  const [arrTabShow, setarrTabShow] = useState([true, false, false, false]);
  const [RptColId, setRptColId] = useState(0);
  const [strOriginalName, setstrOriginalName] = useState("");
  const [strColumnName, setstrColumnName] = useState("");
  const [strDataType, setstrDataType] = useState("String");
  const [strConditionColumn, setstrConditionColumn] = useState("");
  const [isSumColumn, setisSumColumn] = useState(false);
  const [isShow, setisShow] = useState(false);
  const [isFilter, setisFilter] = useState(false);
  const [isOrderBy, setisOrderBy] = useState(false);
  const [IsUpdated, setIsUpdated] = useState(false);
  const [IsSaving, setIsSaving] = useState(false);
  const [iTableKey, setiTableKey] = useState(0); // re-mounts the grid so its inputs show reloaded values
  const arrDatatype = ["String", "DateTime", "decimal"];

  const IsMounted = useRef(true);
  const LoadSeq = useRef(0);

  useEffect(() => {
    IsMounted.current = true;
    Load_ReportSetting("Design");
    return () => {
      IsMounted.current = false;
    };
  }, []);
  const Load_ReportSetting = async (strtabName) => {
    const iSeq = ++LoadSeq.current;
    try {
      const res = await API_FETCH(
        `Reports/View_ReportSetting/${strtabName}/${Number(props.iRptId)}/${_AuthParems.DB}`,
        dispatch
      );
      if (!IsMounted.current || iSeq !== LoadSeq.current) return; // another tab was opened meanwhile
      if (Is_ValidResponse(res, dispatch)) {
        if (strtabName === "UpdateColumns") {
          setarrEntReptCol(Array.isArray(res.EntReptColumns) ? res.EntReptColumns : []);
        } else {
          setarrEntDT(Remember_Types(Array.isArray(res.EntColSetting) ? res.EntColSetting : []));
          setiTableKey((k) => k + 1);
        }
        setarrColSetting(Array.isArray(res.EntRptSetting) ? res.EntRptSetting : []);
      }
    } catch (error) {
      if (IsMounted.current) Show_Message(dispatch, error.message, "error");
    }
  };
  const Save_ReportDesign = async () => {
    if (IsSaving) return;
    try {
      const objInvalid = arrEntDT.find((dt) => !Is_Number(dt.inOrderTo));
      if (objInvalid) {
        Show_Message(dispatch, `Please enter a valid order number for ${objInvalid.originalName || objInvalid.aliasName}`, "info");
        return;
      }
      const objBadAlign = arrEntDT.find(
        (dt) => !Is_Number(dt.fontAlign) || Number(dt.fontAlign) < 1 || Number(dt.fontAlign) > 3
      );
      if (objBadAlign) {
        Show_Message(dispatch, `Text Align for ${objBadAlign.originalName || objBadAlign.aliasName} must be 1 (Left), 2 (Center) or 3 (Right)`, "info");
        return;
      }
      const objBadWidth = arrEntDT.find((dt) => {
        const strWidth = String(dt.reportWidth === null || dt.reportWidth === undefined ? "" : dt.reportWidth).trim().toLowerCase();
        return !(Is_Number(strWidth) && Number(strWidth) > 0) && !strWidth.includes("%") && !strWidth.includes("auto");
      });
      if (objBadWidth) {
        Show_Message(dispatch, `Please enter a valid width for ${objBadWidth.originalName || objBadWidth.aliasName}`, "info");
        return;
      }
      // rb_tbl_reportdesign.AliasName is varchar(100)
      const objLongName = arrEntDT.find((dt) => String(dt.aliasName === null || dt.aliasName === undefined ? "" : dt.aliasName).length > 100);
      if (objLongName) {
        Show_Message(dispatch, `Name of ${objLongName.originalName} is longer than 100 characters`, "info");
        return;
      }
      const objNoName = arrEntDT.find((dt) => String(dt.aliasName === null || dt.aliasName === undefined ? "" : dt.aliasName).trim() === "");
      if (objNoName) {
        Show_Message(dispatch, `Please enter a name for ${objNoName.originalName}`, "info");
        return;
      }
      setIsSaving(true);
      const Update = {
        strTag: "Design",
        EntSumColumns: [],
        objEntRptSet: arrColSetting.length > 0 ? arrColSetting[0] : null,
        RptColumnDesign: arrEntDT,
        strDBName: _AuthParems.DB,
      };
      const res = await API_POST("Reports/Update_ReportSettings", Update, dispatch);
      if (IsMounted.current && Is_ValidResponse(res, dispatch)) {
        setIsUpdated(true);
        Show_Message(dispatch, res.strMessage, "success");
      }
    } catch (error) {
      Show_Message(dispatch, error.message, "error");
    } finally {
      if (IsMounted.current) setIsSaving(false);
    }
  };
  const Save_SummaryDesign = async () => {
    if (IsSaving) return;
    try {
      setIsSaving(true);
      const Update = {
        RptColumnDesign: [],
        EntSumColumns: arrEntDT,
        objEntRptSet: arrColSetting.length > 0 ? arrColSetting[0] : null,
        strTag: "Summary",
        strDBName: _AuthParems.DB,
      };
      const res = await API_POST("Reports/Update_ReportSettings", Update, dispatch);
      if (IsMounted.current && Is_ValidResponse(res, dispatch)) {
        setIsUpdated(true);
        Show_Message(dispatch, res.strMessage, "success");
      }
    } catch (error) {
      Show_Message(dispatch, error.message, "error");
    } finally {
      if (IsMounted.current) setIsSaving(false);
    }
  };
  const Clear_Columns = () => {
    setRptColId(0); // FIX: "New Column" after editing a column overwrote that column
    setstrOriginalName("");
    setstrColumnName("");
    setstrDataType("String");
    setstrConditionColumn("");
    setisSumColumn(false);
    setisShow(false);
    setisFilter(false);
    setisOrderBy(false);
  };
  const Validate_Column = (IsUpdate) => {
    if (IsUpdate && Number(RptColId) === 0) {
      Show_Message(dispatch, "Please double-click a column in the list to update it", "info");
      return false;
    }
    if (strOriginalName.trim().length === 0) {
      Show_Message(dispatch, "Please Enter Column Name", "info");
      return false;
    }
    if (strColumnName.trim().length === 0) {
      Show_Message(dispatch, "Please Enter Column Root Name", "info");
      return false;
    }
    if (arrDatatype.indexOf(strDataType) < 0) {
      Show_Message(dispatch, "Please Select Data Type", "info");
      return false;
    }
    // rb_tbl_reportcolumns: RptColName / RptColRoot / ConditionColumn are varchar(200)
    if (strOriginalName.trim().length > 200 || strColumnName.trim().length > 200 || strConditionColumn.trim().length > 200) {
      Show_Message(dispatch, "Column Name, Column Root and Condition Column can have at most 200 characters", "info");
      return false;
    }
    if (isFilter && strDataType === "String" && strConditionColumn.trim().length === 0) {
      Show_Message(dispatch, "Please Enter Condition Column (needed for a String report filter)", "info");
      return false;
    }
    const strName = strOriginalName.trim().toLowerCase();
    const objDuplicate = arrEntReptCol.find(
      (col) => String(col.rptColName || "").trim().toLowerCase() === strName && Number(col.rptColId) !== Number(RptColId)
    );
    if (objDuplicate) {
      Show_Message(dispatch, "A column with this name already exists in this report", "info");
      return false;
    }
    return true;
  };
  const Save_ReportColumn = async (IsUpdate) => {
    if (IsSaving) return;
    try {
      setIsSaving(true);
      const iColId = IsUpdate ? Number(RptColId) : 0;
      const objRptCol = [
        {
          RptColId: iColId,
          RptId: Number(props.iRptId),
          RptColName: strOriginalName.trim(),
          RptColRoot: strColumnName.trim(),
          DataType: strDataType,
          ViewQuery: "",
          ConditionQuery: "",
          RptSumColRoot: "",
          IsSumCol: Number(isSumColumn),
          IsChecked: Number(isShow),
          IsDefaultOrderBy: Number(isOrderBy),
          IsReportFilter: Number(isFilter),
          ConditionColumn: strConditionColumn.trim(),
        },
      ];
      const Update = {
        iRptId: Number(props.iRptId),
        iRptColId: iColId,
        RptColumn: objRptCol,
        strDBName: _AuthParems.DB,
      };
      const res = await API_POST("Reports/InsUpd_ReportColumn", Update, dispatch);
      if (IsMounted.current && Is_ValidResponse(res, dispatch)) {
        Clear_Columns();
        tab_click(0, "Design");
        setIsUpdated(true);
        Show_Message(dispatch, res.strMessage, "success");
      }
    } catch (error) {
      Show_Message(dispatch, error.message, "error");
    } finally {
      if (IsMounted.current) setIsSaving(false);
    }
  };
  const View_ReportColumn = (objCol) => {
    if (!objCol) return;
    setRptColId(Number(objCol.rptColId) || 0);
    setstrOriginalName(objCol.rptColName || "");
    setstrColumnName(objCol.rptColRoot || "");
    setstrDataType(arrDatatype.find((t) => t.toLowerCase() === String(objCol.dataType || "").trim().toLowerCase()) || "String");
    setstrConditionColumn(objCol.conditionColumn || "");
    setisSumColumn(Boolean(Number(objCol.isSumCol)));
    setisShow(Boolean(Number(objCol.isChecked)));
    setisFilter(Boolean(Number(objCol.isReportFilter)));
    setisOrderBy(Boolean(Number(objCol.isDefaultOrderBy)));
  };
  const Column = [
    {
      Header: "Field Name",
      style: { justifyContent: "left" },
      accessor: "originalName",
      show: arrTabShow[0],
    },
    {
      Header: "Field Name",
      accessor: "aliasName",
      style: { justifyContent: "left" },
      show: !arrTabShow[0],
    },
    {
      Header: "Name",
      id: "Alias",
      style: { justifyContent: "center" },
      cell: ({ rowinfo }) => (
        <input
          type="text"
          className="form-control"
          defaultValue={rowinfo.aliasName}
          maxLength={100}
          onClick={(e) => e.target.select()}
          onChange={(e) => (rowinfo.aliasName = e.target.value)}
        ></input>
      ),
      show: arrTabShow[0],
    },
    {
      Header: "In Order",
      maxWidth: 100,
      minWidth: 100,
      id: "InOrderTo",
      style: { justifyContent: "center" },
      cell: ({ rowinfo }) => (
        <input
          type="text"
          className="form-control"
          defaultValue={rowinfo.inOrderTo}
          onClick={(e) => e.target.select()}
          onChange={(e) => Set_Field(rowinfo, "inOrderTo", e.target.value)}
        ></input>
      ),
      show: arrTabShow[0],
    },
    {
      Header: "Width",
      maxWidth: 100,
      minWidth: 100,
      id: "Width",
      style: { justifyContent: "center" },
      cell: ({ rowinfo }) => (
        <input
          type="text"
          className="form-control"
          defaultValue={rowinfo.reportWidth}
          onClick={(e) => e.target.select()}
          onChange={(e) => Set_Field(rowinfo, "reportWidth", e.target.value)}
        ></input>
      ),
      show: arrTabShow[0],
    },
    {
      Header: "Text Align",
      maxWidth: 100,
      minWidth: 100,
      id: "fontAlign",
      style: { justifyContent: "center" },
      cell: ({ rowinfo }) => (
        <input
          type="text"
          className="form-control"
          defaultValue={rowinfo.fontAlign}
          onClick={(e) => e.target.select()}
          onChange={(e) => Set_Field(rowinfo, "fontAlign", e.target.value)}
        ></input>
      ),
      show: arrTabShow[0],
    },
    {
      Header: "Show",
      id: "showInReport",
      maxWidth: 100,
      minWidth: 100,
      style: { justifyContent: "center" },
      cell: ({ rowinfo }) => (
        <input
          type="checkbox"
          className="form-check"
          defaultChecked={rowinfo.showInReport}
          onChange={(e) => (rowinfo.showInReport = e.target.checked)}
        ></input>
      ),
      show: arrTabShow[0],
    },
    {
      Header: "Show",
      id: "isChecked",
      maxWidth: 100,
      minWidth: 100,
      show: !arrTabShow[0] ? true : false,
      style: { justifyContent: "center" },
      cell: ({ rowinfo }) => (
        <input
          type="checkbox"
          className="form-check"
          defaultChecked={rowinfo.isChecked}
          onChange={(e) => (rowinfo.isChecked = e.target.checked)}
        ></input>
      ),
    },
  ];
  const ReportColumn = [
    {
      Header: "Report Column",
      style: { justifyContent: "left" },
      accessor: "rptColName",
    },
    {
      Header: "Root Column",
      accessor: "rptColRoot",
      style: { justifyContent: "left" },
    },
    {
      Header: "Data Type",
      accessor: "dataType",
      style: { justifyContent: "left" },
      minWidth: 100,
      maxWidth: 100,
    },
    {
      Header: "Condition Column",
      accessor: "conditionColumn",
      minWidth: 120,
      style: { justifyContent: "left" },
    },
    {
      Header: "Order By",
      style: { justifyContent: "center" },
      accessor: "isDefaultOrderBy",
      maxWidth: 100,
      minWidth: 100,
    },
    {
      Header: "Filter",
      style: { justifyContent: "center" },
      accessor: "isReportFilter",
      maxWidth: 70,
      minWidth: 70,
    },
    {
      Header: "Sum",
      style: { justifyContent: "center" },
      accessor: "isSumCol",
      maxWidth: 70,
      minWidth: 70,
    },
    {
      Header: "Show",
      style: { justifyContent: "center" },
      accessor: "isChecked",
      maxWidth: 100,
      minWidth: 100,
    },
  ];
  const tab_click = (tabindex, tabName) => {
    let line = document.getElementById("tab-line");
    let lable = $(`.trans-buttons label`);
    if (line && lable[tabindex]) {
      let fromleft = lable[tabindex].offsetLeft;
      let width = lable[tabindex].clientWidth;
      line.style.left = fromleft + "px";
      line.style.width = width + "px";
    }
    $(`.trans-buttons label:eq(${tabindex})`)
      .addClass("active")
      .siblings()
      .removeClass("active");
    let EntTab = arrTabShow.map((Dt, Index) => Index === tabindex);
    setarrTabShow(EntTab);
    if (tabindex === 2 || tabindex === 3) Clear_Columns(); // each tab starts clean
    if (tabindex === 0 || tabindex === 1 || tabindex === 2) Load_ReportSetting(tabName);
    if (tabindex === 3) Load_ReportSetting("UpdateColumns"); // for the duplicate-name check
  };
  return (
    <div className="popup-container">
      <div className="popup-content medium">
        <div className="popup-header">
          <h5>Report Setting</h5>
          <div className="icon-popup-btn-grp">
            <span className="icon-btn" onClick={() => props.Close(IsUpdated)}>
              <i className="fa-regular fa-rectangle-xmark"></i>
            </span>
          </div>
        </div>
        <div className="popup-body">
          <div className="row">
            <div className="trans-tab">
              <div className="trans-buttons">
                <label
                  onClick={(e) => tab_click(0, "Design")}
                  className="active"
                >
                  Design
                </label>
                <label onClick={(e) => tab_click(1, "Summary")}>Summary</label>
                <label onClick={(e) => tab_click(2, "UpdateColumns")}>
                  Update Column
                </label>
                <label onClick={(e) => tab_click(3, "Columns")}>
                  New Columns
                </label>
                <div id="tab-line"></div>
              </div>
            </div>
            {!arrTabShow[2] && !arrTabShow[3] && (
              <ReactTable
                key={`rpt-set-${arrTabShow[0] ? "d" : "s"}-${iTableKey}`}
                columns={Column}
                data={arrEntDT}
                minRows={5}
                row_click={(ProInfo, Index) => {}}
                row_doubleclick={(ProInfo, Index) => {}}
                background={true}
                className="full-table"
              />
            )}
            {arrTabShow[2] && (
              <div className="row">
                <div className="col-sm-12 col-md-4">
                  <label>Column Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={strOriginalName}
                    onChange={(e) => setstrOriginalName(e.target.value)}
                    placeholder="Enter Column Name"
                    maxLength={200}
                  />
                </div>
                <div className="col-sm-12 col-md-4">
                  <label>Column Root</label>
                  <input
                    type="text"
                    className="form-control"
                    value={strColumnName}
                    onChange={(e) => setstrColumnName(e.target.value)}
                    placeholder="Enter Column Root Name"
                    maxLength={200}
                  />
                </div>
                <div className="col-sm-6 col-md-3">
                  <label>Data Type</label>
                  <CustomeIndexSelectOption
                    optionparem="isoptionShow10"
                    showoption={_parem.isoptionShow10}
                    placeholder="Select Data Type"
                    select_value={(val) => setstrDataType(val)}
                    defaultval={strDataType}
                    arrydata={arrDatatype}
                    EmptVal="Data Type"
                  />
                </div>
                <div className="col-sm-6 col-md-4">
                  <label>Condition Column</label>
                  <input
                    type="text"
                    className="form-control"
                    value={strConditionColumn}
                    onChange={(e) => setstrConditionColumn(e.target.value)}
                    placeholder="Enter Condition Column Name"
                    maxLength={200}
                  />
                </div>
                <div className="col-sm-6 col-md-2">
                  <label>Order By</label>
                  <input
                    type="checkbox"
                    className="form-check"
                    checked={isOrderBy}
                    onChange={(e) => setisOrderBy(!isOrderBy)}
                  />
                </div>
                <div className="col-sm-6 col-md-2">
                  <label>Report Filter</label>
                  <input
                    type="checkbox"
                    className="form-check"
                    checked={isFilter}
                    onChange={(e) => setisFilter(!isFilter)}
                  />
                </div>
                <div className="col-sm-6 col-md-2">
                  <label>Sum Column</label>
                  <input
                    type="checkbox"
                    className="form-check"
                    checked={isSumColumn}
                    onChange={(e) => setisSumColumn(!isSumColumn)}
                  />
                </div>
                <div className="col-sm-6 col-md-2">
                  <label>Show Sum Column</label>
                  <input
                    type="checkbox"
                    className="form-check"
                    checked={isShow}
                    onChange={(e) => setisShow(!isShow)}
                  />
                </div>
                <ReactTable
                  columns={ReportColumn}
                  data={arrEntReptCol}
                  minRows={5}
                  row_click={(rowInfo, Index) => {}}
                  row_doubleclick={(rowInfo, Index) => {
                    View_ReportColumn(rowInfo);
                  }}
                  background={true}
                  className="full-table"
                />
              </div>
            )}
            {arrTabShow[3] && (
              <div className="row">
                <div className="col-sm-12 col-md-4">
                  <label>Column Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={strOriginalName}
                    onChange={(e) => setstrOriginalName(e.target.value)}
                    placeholder="Enter Column Name"
                    maxLength={200}
                  />
                </div>
                <div className="col-sm-12 col-md-4">
                  <label>Column Root</label>
                  <input
                    type="text"
                    className="form-control"
                    value={strColumnName}
                    onChange={(e) => setstrColumnName(e.target.value)}
                    placeholder="Enter Column Root Name"
                    maxLength={200}
                  />
                </div>
                <div className="col-sm-6 col-md-3">
                  <label>Data Type</label>
                  <CustomeIndexSelectOption
                    optionparem="isoptionShow10"
                    showoption={_parem.isoptionShow10}
                    placeholder="Select Data Type"
                    select_value={(val) => setstrDataType(val)}
                    defaultval={strDataType}
                    arrydata={arrDatatype}
                    EmptVal="Data Type"
                  />
                </div>
                <div className="col-sm-6 col-md-4">
                  <label>Condition Column</label>
                  <input
                    type="text"
                    className="form-control"
                    value={strConditionColumn}
                    onChange={(e) => setstrConditionColumn(e.target.value)}
                    placeholder="Enter Condition Column Name"
                    maxLength={200}
                  />
                </div>
                <div className="col-sm-6 col-md-2">
                  <label>Report Filter</label>
                  <input
                    type="checkbox"
                    className="form-check"
                    checked={isFilter}
                    onChange={(e) => setisFilter(!isFilter)}
                  />
                </div>
                <div className="col-sm-6 col-md-2">
                  <label>Sum Column</label>
                  <input
                    type="checkbox"
                    className="form-check"
                    checked={isSumColumn}
                    onChange={(e) => setisSumColumn(!isSumColumn)}
                  />
                </div>
                <div className="col-sm-6 col-md-2">
                  <label>Show In Report</label>
                  <input
                    type="checkbox"
                    className="form-check"
                    checked={isShow}
                    onChange={(e) => setisShow(!isShow)}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="popup-footer">
          <div className="popup-btn-group">
            {arrTabShow[0] && (
              <button
                onClick={(e) => Save_ReportDesign()}
                className="btn-fabgreen"
                disabled={IsSaving}
              >
                Update&nbsp;<i className="fas fa-save"></i>
              </button>
            )}
            {arrTabShow[0] && (
              <button
                onClick={(e) => Load_ReportSetting("Design")}
                className="btn-fabgreen"
              >
                Clear&nbsp;<i className="fa-solid fa-broom"></i>
              </button>
            )}
            {arrTabShow[1] && (
              <button
                onClick={(e) => Save_SummaryDesign()}
                className="btn-fabgreen"
                disabled={IsSaving}
              >
                Update&nbsp;<i className="fas fa-save"></i>
              </button>
            )}
            {arrTabShow[1] && (
              <button
                onClick={(e) => Load_ReportSetting("Summary")}
                className="btn-fabgreen"
              >
                Clear&nbsp;<i className="fa-solid fa-broom"></i>
              </button>
            )}
            {arrTabShow[2] && (
              <button
                className="btn-fabgreen"
                disabled={IsSaving}
                onClick={() => {
                  if (Validate_Column(true))
                    Ask_Question(
                      dispatch,
                      () => Save_ReportColumn(true),
                      "Do You Want to Update Report Column?"
                    );
                }}
              >
                Save&nbsp;<i className="fas fa-save"></i>
              </button>
            )}
            {arrTabShow[2] && (
              <button className="btn-fabgreen" onClick={() => Clear_Columns()}>
                Clear&nbsp;<i className="fa-solid fa-broom"></i>
              </button>
            )}
            {arrTabShow[3] && (
              <button
                className="btn-fabgreen"
                disabled={IsSaving}
                onClick={() => {
                  if (Validate_Column(false))
                    Ask_Question(
                      dispatch,
                      () => Save_ReportColumn(false),
                      "Do You Want to Add New Report Column?"
                    );
                }}
              >
                Save&nbsp;<i className="fas fa-save"></i>
              </button>
            )}
            {arrTabShow[3] && (
              <button className="btn-fabgreen" onClick={() => Clear_Columns()}>
                Clear&nbsp;<i className="fa-solid fa-broom"></i>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportSetting;
